
function main() {
    const header = document.querySelector('.header__container')

    if (!header) return

    const { height } = header.getBoundingClientRect()

    let up = false
    let old = window.scrollY

    window.addEventListener('scroll', () => {

        up = (old > window.scrollY)

        if (window.scrollY > height * 2 && !up) {
            header.classList.add('hidden')
            header.classList.remove('sticky')
        } else if (header.classList.contains('hidden')) {
            header.classList.remove('hidden')
            header.classList.add('sticky')
        } else if (header.classList.contains('sticky')) {
            if (window.scrollY <= height) {
                header.classList.remove('sticky')
            }
        }

        old = window.scrollY
    })
}

main()
